import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, mergeMap, takeUntil } from 'rxjs/operators'

import { getRangeFromDateFilter } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { SCANBACK_CHANGE } from 'containers/Dashboard/Home/constants'
import { selectWithoutScanback } from 'containers/Dashboard/Home/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE } from '../Flow/constants'
import { selectDateFilter } from '../Flow/selectors'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DATA_REQUEST_ASYNC.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    ),
    filter((action) => {
      if (
        action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS ||
        action.type === SCANBACK_CHANGE
      )
        return matchURL(URL_CONST.dashboard.mitigation)
      return true
    }),
    mergeMap(() =>
      api.dashboard
        .getThreatProtection(
          state$.value.partnerOptions.selectedCompany?.value,
          getRangeFromDateFilter(selectDateFilter(state$.value)),
          selectWithoutScanback(state$.value),
          { mitigation: false, mailboxAnomaly: false, topProfiles: false, incidentsStats: true }
        )
        .pipe(
          mergeMap((response) => of(fetchDataSuccess(response.response))),
          catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
          takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

export default fetchDataEpic
